import type {
  BetterstartCommandRuntime,
  GenerateCommandOptions
} from '@cli-types/core-engine/commands.js'
import { renderCommandHelpText } from '@core-engine/templates/renderers/commands/command-help.js'
import { Command } from 'commander'

export function createGenerateCommand(runtime: BetterstartCommandRuntime): Command {
  return new Command('generate')
    .alias('g')
    .description('Generate entity or form from a JSON schema')
    .argument('[schema]', 'Schema name (e.g. posts, categories, contact)')
    .option('-f, --force', 'Overwrite existing generated files', false)
    .option(
      '--accept-generated',
      'Accept generated output for files that would otherwise get merge conflicts',
      false
    )
    .option('-a, --all', 'Regenerate all schemas', false)
    .option('--interactive', 'Prompt during generate --all', false)
    .option('--skip-migration', 'Skip running db:push after generation', false)
    .option('--cwd <path>', 'Project root path')
    .addHelpText('after', renderCommandHelpText('generate'))
    .action((schemaName: string | undefined, options: GenerateCommandOptions) =>
      runtime.runGenerate(schemaName, options)
    )
}
